import { XDActions } from './actions'
import { IXDMessage, XDMessage } from './message'

export interface IXDResponse extends IXDMessage<any> {
    replyTo: string // id of request
}

export class XDResponse extends XDMessage<any> implements IXDResponse {
    constructor(
        public readonly action: XDActions,
        public readonly replyTo: string,
        public data?: any,
        public readonly ts = Date.now(),
        hash?: number
    ) {
        super(action, data, ts, hash)
        this.updateHash(hash)
    }
}
